import { hotEvents } from "@/mocks/home";
import SectionHeader from "./SectionHeader";

const rankClass = (rank: number) =>
  rank <= 3
    ? "bg-primary-500 text-background-50"
    : "bg-background-100 text-foreground-600";

export default function HotBoard() {
  return (
    <section id="hot" className="bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <SectionHeader
          index="01"
          kicker="实时热榜"
          title="今日都在吃哪个瓜"
          desc="榜单由各平台热度加权后汇总，每节点均标注首发信源；点击任一条目可展开该事件的完整前因后果与时间线。"
          href="#grid"
          linkLabel="周热度总榜"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1.65fr_1fr]">
          {/* hot list */}
          <div className="divide-y divide-background-200 overflow-hidden rounded-xl border border-background-200 bg-background-50">
            {hotEvents.map((e) => (
              <a
                key={e.rank}
                href="#feature"
                className="group flex gap-4 px-4 py-4 transition-colors hover:bg-background-100/70 md:px-5"
              >
                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-sm font-bold ${rankClass(e.rank)}`}
                >
                  {e.rank}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] font-semibold text-secondary-800 whitespace-nowrap">
                      {e.tag}
                    </span>
                    <h3 className="truncate font-semibold text-foreground-950 transition-colors group-hover:text-primary-700">
                      {e.title}
                    </h3>
                  </div>
                  <p className="mt-1.5 line-clamp-2 text-sm text-foreground-600">{e.summary}</p>
                </div>
                <div className="flex shrink-0 flex-col items-end justify-between">
                  <span className="font-label text-sm font-bold text-primary-600">{e.heat}</span>
                  <span
                    className={`flex items-center gap-0.5 text-[11px] ${e.delta >= 0 ? "text-accent-600" : "text-foreground-400"}`}
                  >
                    <i
                      className={
                        e.delta >= 0 ? "ri-arrow-up-line text-xs" : "ri-arrow-down-line text-xs"
                      }
                    />
                    {Math.abs(e.delta)} 名
                  </span>
                </div>
              </a>
            ))}
          </div>

          {/* operations side rail */}
          <aside className="flex flex-col gap-6">
            <div className="rounded-xl border border-background-200 bg-background-50 p-5">
              <h3 className="flex items-center gap-2 font-heading text-lg text-foreground-950">
                <i className="ri-focus-3-line text-primary-600" />
                榜单怎么算
              </h3>
              <ul className="mt-4 space-y-3 text-sm text-foreground-600">
                <li className="flex gap-3">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                    <i className="ri-database-2-line text-xs" />
                  </span>
                  聚合微博 / 抖快 / B 站 / 小红书讨论声量
                </li>
                <li className="flex gap-3">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className="ri-time-line text-xs" />
                  </span>
                  24 小时滚动热度，每 10 分钟刷新一次
                </li>
                <li className="flex gap-3">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-800">
                    <i className="ri-shield-check-line text-xs" />
                  </span>
                  已标注「存疑」的节点不计入热榜权重
                </li>
              </ul>
            </div>

            <div className="relative overflow-hidden rounded-xl bg-primary-500 p-5 text-background-50">
              <i className="ri-send-plane-fill absolute -right-3 -top-3 text-[70px] text-background-50/15" />
              <h3 className="font-heading text-xl">你手里有前因后果的线索？</h3>
              <p className="mt-2 text-sm leading-relaxed text-background-100">
                收到投稿后由编辑核对信源，缺的那段经过补上后会在榜单与专题页同步。
              </p>
              <a
                href="#faq"
                className="mt-4 inline-flex items-center gap-1.5 rounded-md bg-background-50 px-4 py-2 text-sm font-semibold text-primary-700 transition hover:bg-background-100 whitespace-nowrap cursor-pointer"
              >
                提供线索
                <i className="ri-arrow-right-line" />
              </a>
            </div>

            <div className="rounded-xl border border-dashed border-accent-300 bg-accent-100/50 p-5">
              <p className="text-xs font-bold uppercase tracking-wider text-accent-800">官方提示</p>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                本页所有事件均基于公开渠道整理。若您是当事一方希望标注或修订某节点，
                可通过右侧「纠错」入口联系我们，48 小时内处理。
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}